

























































































import dayjs from 'dayjs';
import * as R from 'ramda';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { RepeatType } from '@/API';
import { TextRuleType } from '@/components/atoms/neon/CustomTextField.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { newPortalDate } from '@/utils/PortalDate';
import { getFormattedDateWithoutTime } from '@/utils/RRuleUtils';
import { INFINITE_DATE } from '@/utils/consts';

@Component
export default class PeriodDateInput extends Vue {
  @Prop()
  private label!: string;
  @Prop()
  private to!: string;
  @Prop()
  private from!: string;
  @Prop()
  private dateFrom!: string | null;

  @Prop()
  private dateTo!: string | null;

  @Prop()
  private selectedRepeatType!: any;

  @Prop({ required: false, default: false })
  private allowFromToday!: boolean;

  @Prop({ required: false, default: false })
  private isReadOnly!: boolean;

  private noRepeat: RepeatType = RepeatType.NoRepeat;

  private dateFromValue: string | null = null;

  private dateToValue: string | null = null;

  private dateFromMenu: boolean = false;

  private dateToMenu: boolean = false;

  public async created(): Promise<void> {
    this.dateFromValue = this.dateFrom;
    if (this.dateTo !== INFINITE_DATE) {
      this.dateToValue = this.dateTo;
    }
  }

  private get minDate() {
    const todayDate = getFormattedDateWithoutTime(dayjs().toDate());
    const tomorrowDate = getFormattedDateWithoutTime(
      newPortalDate(dayjs())
        .add(1, 'day')
        .toDate()
    );
    return this.allowFromToday ? todayDate : tomorrowDate;
  }

  private get moreThanEqualToDateFrom() {
    return this.dateFromValue ? this.dateFromValue : this.minDate;
  }

  private get isNotNoRepeat() {
    return this.selectedRepeatType !== this.noRepeat;
  }

  private get formatDateFrom() {
    return this.formatDate(this.dateFromValue);
  }

  private get formatDateTo() {
    return this.formatDate(this.dateToValue);
  }

  private rules: { [key: string]: TextRuleType } = {
    required: value => !!value || this.ruleInputRequired,
  };

  private formatDate(date: string | null) {
    return date ? R.replace(/-/g, '/', date) : null;
  }

  private ruleInputRequired = i18n.tc('portal.ruleInputRequired');

  @Emit('changedDateFrom')
  private onChangeDateFrom(dateFrom: string | null) {}

  @Emit('changedDateTo')
  private onChangeDateTo(dateTo: string | null) {}
}
